// Get the container
const slideContainer8 = document.querySelector('.slide_container8');

// URLs for desktop images
const desktopImageUrls8 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/1_521f54bb-b42a-4978-8ba0-7127088fea3b.gif?v=1723781506',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/2_755d0478-f565-49b6-af93-ff57526ec32f.gif?v=1723781506',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/3.gif?v=1723781509',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/4.gif?v=1723781509'
];

// URLs for mobile images
const mobileImageUrls8 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/1_438a1d76-4e45-4871-82fa-926c4f946edb.gif?v=1723790007',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/2_c3e716b7-27c5-4f3c-9bc8-391bdfdb96c1.gif?v=1723790008',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/3_3d5548a1-99b6-4113-90f1-c4b7cfbf77df.gif?v=1723790010',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/4_cfa86c76-f0de-4c9c-a944-47cc0cdbb41a.gif?v=1723790007'
];

// Function to determine screen size and load appropriate images
function loadImages8() {
    const isMobile = window.innerWidth <= 768;
    console.log('isMobile:', isMobile); // Log whether the device is identified as mobile

    // Clear the container
    slideContainer8.innerHTML = '';

    if (isMobile) {
        console.log('Loading mobile images'); // Log the action of loading mobile images
        // Create and append mobile images
        mobileImageUrls8.forEach(url => {
            const mobileImage = document.createElement('img');
            mobileImage.src = url;
            mobileImage.alt = 'Mobile image';
            mobileImage.className = 'mobile-image8';
            slideContainer8.appendChild(mobileImage);
        });
    } else {
        console.log('Loading desktop images'); // Log the action of loading desktop images
        // Create and append desktop images
        desktopImageUrls8.forEach(url => {
            const desktopImage = document.createElement('img');
            desktopImage.src = url;
            desktopImage.alt = 'Desktop image';
            desktopImage.className = 'desktop-image8';
            slideContainer8.appendChild(desktopImage);
        });
    }
}

// Call the function initially
document.addEventListener("DOMContentLoaded", function() {
    loadImages8();
    // Listen for window resize events to update images if necessary
    window.addEventListener('resize', loadImages8);

    // Set the target end time (June 6, 2024, at 11:00 AM ET)
    const targetEndTime8 = new Date('2024-06-06T11:00:00-04:00').getTime();

    function updateCountdown8() {
        const currentTime = new Date().getTime();
        const timeDifference = targetEndTime8 - currentTime;

        // Check if the countdown has ended
        if (timeDifference <= 0) {
            document.getElementById('countdown8').textContent = "Ready!";
            return;
        }

        const hours = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        document.getElementById('countdown8').textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        setTimeout(updateCountdown8, 1000);
    }

    updateCountdown8();
});
